export default __webpack_public_path__ + "static/media/fivedot.d3857950.png";